import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function approvingOrderReducer(state = initialState.approvingOrder, action) {
  if (action.type === types.BEGIN_APPROVE_ORDER) {
    return true;
  } if (action.type === types.APPROVE_ORDER_SUCCESS) {
    return false;
  }

  return state;
}
